import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IExpander } from "@models/entity-models";

@Kbo(CToken.Expander)
export class Expander extends UiObject implements IExpander {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public expanded: boolean;
    public $expandedInPreview: boolean;
    public icon: string;
    public iconStyle: string;
    public mediaPath: string;
    
    private _children: UiObject[];
    @Enumerable()
    public get children(): UiObject[] {
        if (!this._children) this._children = [];
        return this._children;
    }
    public set children(val) {
        this._children = val;
    }
   

    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return this.filterChildren<T>(tokens,
            this.children
        );
    }

    public allowedChildren(rootType: CToken): CToken[] {
        let c = this.containerChildren(rootType);
        c.removeWhere(c => c.key.equalsAny( //don't allow expanders in expanders
            CToken.Accordion.key,
            CToken.Expander.key
        ));
        return c;
    }
}
